// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promotion-msg .promo-text[data-v-b4fc8e14]{margin-left:-15px}", ""]);
// Exports
module.exports = exports;
